import { map } from './layers-init.js'
import { checkForNewLayers } from './data-manage.js'
import { weatherTilesGroup, generateTileLayers, layerLightning, lightning } from './layers.js'
import { baronTiles } from './productMapping.js';
import { popupAlertType } from './popup.js';

function toggleLayers(domId, weatherLayers, alertType) {
  document.getElementById(domId).addEventListener('click', _ => {
    checkForNewLayers()
    map.closePopup()
    map.off('click')
    lightning.clearLayers()
    map.removeLayer(weatherTilesGroup)
    generateTileLayers(weatherLayers)
    layerLightning()
    map.on('click', L.bind(popupAlertType, null, alertType))
  })
}

function toggleHurricaneLayers(domId, weatherLayers) {
  document.getElementById(domId).addEventListener('click', _ => {
    checkForNewLayers()
    map.closePopup()
    map.off('click')
    lightning.clearLayers()
    map.removeLayer(weatherTilesGroup)
    generateTileLayers(weatherLayers)
    map.setView([25.0, -60.0], 4)
  })
}

function toggleLayersDefaultLayout() {
  toggleLayers('iradar-radar', [baronTiles.alerts.polygon, baronTiles.radar.composite_250m], 'poly')
  toggleLayers('iradar-alerts', [baronTiles.alerts.county_polygon_combined], 'all-poly')
  toggleHurricaneLayers('iradar-hurricane', [baronTiles.tropical.nhc])
}

export { toggleLayersDefaultLayout }